<template>
  <div>
    <my-loader v-if="isLoading"></my-loader>
    <ExecutorWizardEditLayout
      v-if="driver && isWizardReturn"
      title="Редактирование водителя"
      description="Измените данные водителя-исполнителя."
      >
        <DriverForm
        mode="edit"
        :initial-data="driver"
          :errors="formErrors"
        @update="updateDriver"
        @closeForm="closeForm"
      />
    </ExecutorWizardEditLayout>
    <div v-if="driver && !isWizardReturn" class="cards">
      <div class="card-item">
         <DriverInfo
           :driver="driver"
           :errors="formErrors"
           @updateDriver="updateDriver"
           @closeForm="closeForm"
         />
        
         <guard-button v-if="!isWizardReturn" :model="'drivers'" :id="driver.id"/>
      </div>

       <div v-if="driver.security_info && !isWizardReturn" class="">
        <DriverSecurityInfo class="card-item" :security="driver.security_info[0]" />
      </div>

    </div>
    <div v-if="!driver"><h2>Нет Данных</h2></div>
  </div>
</template>


<script>
import { useStore } from 'vuex'
import { computed,onMounted } from 'vue'
import { dateValid } from '@/hooks/formatDate.js'
import DriverInfo from '@/pages/securityCheck/components/DriverInfo.vue'
import DriverForm from '@/components/forms/DriverForm.vue'
import ExecutorWizardEditLayout from '@/components/UI/ExecutorWizardEditLayout.vue'
import DriverSecurityInfo from '@/pages/securityCheck/components/DriverSecurityInfo.vue'
import { useRoute, useRouter } from 'vue-router'
import { isExecutorWizardReturn, refreshWizardItem, returnToExecutorWizard } from './executorWizardReturn'
import { useExecutorWizardStore } from '@/stores/executorWizard'

export default {
  name: 'DriverDetail',
  components:{
    DriverSecurityInfo,
    DriverInfo,
    DriverForm,
    ExecutorWizardEditLayout,
  },
  setup(){
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const wizard = useExecutorWizardStore()
    const isWizardReturn = isExecutorWizardReturn(route)

    onMounted(()=>{
      store.dispatch('apiStorage/getItem',{model:'drivers',params:{id:route.params.id}})
    })

    const spliter = date =>{
      return date.split('T')[0]
    }
    
    const is_valid = date=>{
      return dateValid(date)
    }

    const updateDriver = async form =>{
      const ok = await store.dispatch('apiStorage/updateItem',{model:'drivers',form})
      if (!ok) return
      await store.dispatch('apiStorage/getItem', {
        model: 'drivers',
        params: { id: route.params.id },
      })
      if (isWizardReturn) {
        refreshWizardItem(wizard, route, store.state.apiStorage.drivers.item)
        await returnToExecutorWizard(router)
      }
    }

    const closeForm = () => {
      if (isWizardReturn) returnToExecutorWizard(router)
    }

    return {
      spliter,
      updateDriver,
      driver:computed(()=> store.state.apiStorage.drivers.item),
      formErrors:computed(()=> store.state.apiStorage.drivers.formErrors),
      isLoading:computed(() => store.state.apiStorage.drivers.statusLoading),
      isWizardReturn,
      closeForm,
    }
  }
}
</script>

<style scoped>
.item-content{
  max-width: 250px;
  width: 100%;
}

.pair-content{
  display: flex;
  justify-content: space-around;
  padding-top: 10px;
  
}

.liner{
  border-bottom: 1px solid rgba(230,194,118, 1) ;
  padding-bottom: 3px;
}

.footer{
  display: flex;
  justify-content: space-around;
  align-items: center; 
  margin-top: 50px;
}
.footer-content{
  margin: 0;
  width: 60%;
  display: flex;
  justify-content: space-around;
}
.bg-success{
  border-radius: 2px;
  padding: 2px;
  background-color: rgba(152,236,131,0.6);
}

.bg-denied{
  border-radius: 2px;
  padding: 2px;
  background-color: rgba(182,0,24,0.4);
}

.cards{
  display: flex;
  flex-direction: column;
  padding: 15px;
}

.card-item{
  border-radius: 10px;
  margin-top: 5px;
  border: 1px solid #ccc;
  padding: 15px;
}
.header-content{
  display: flex;
  justify-content: flex-start;
  margin-right: 20px;
  align-items: center;
}
</style>
